import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useTheme, FormControl, FormControlLabel, Checkbox, Stack } from "@mui/material";
import { profileStore } from "@/stores/Stores";
import { POLICY_PAGE_URL, TERMS_PAGE_URL } from "@/common/config";
import getStyles from "./styles";

export const NewsAndTerms = observer(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  const styles = getStyles(theme);
  const userProfile = profileStore.profile;

  return (
    <Stack sx={styles.section}>
      <FormControl fullWidth sx={styles.newsletter}>
        <FormControlLabel
          label={t("News, product information and offers by email (sent regularly, monthly)")}
          control={
            <Checkbox
              checked={userProfile.newsletter === "yes"}
              value={userProfile.newsletter}
              onChange={e => {
                userProfile.newsletter = e.target.checked ? "yes" : "no";
              }}
            />
          }
        />
      </FormControl>
      <FormControl fullWidth sx={styles.tos} error={profileStore.showErrors && profileStore.profile.termsAccepted !== "yes"}>
        <FormControlLabel
          control={
            <Checkbox
              checked={userProfile.termsAccepted === "yes"}
              value={userProfile.termsAccepted}
              onChange={e => {
                userProfile.termsAccepted = e.target.checked ? "yes" : "no";
              }}
            />
          }
          label={
            <>
              {t("I accept the")}{" "}
              <a target="_blank" rel="noreferrer" href={TERMS_PAGE_URL}>
                {t("terms of use")}
              </a>{" "}
              {t("and the")}{" "}
              <a target="_blank" rel="noreferrer" href={POLICY_PAGE_URL}>
                {t("privacy policy")}
              </a>
              .
            </>
          }
        />
      </FormControl>
    </Stack>
  );
});
